import { RewardsIconSchema } from "@apps/rewards/schemas/RewardsIconSchema";
import { RewardsDiscountExtraInfoRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsDiscountRewardSchema";
import { RewardsFreeProductRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsFreeProductRewardSchema";
import { RewardsGiftCardRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsGiftCardRewardSchema";
import { RewardsPointsRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsPointsRewardSchema";
import {
    array,
    boolean,
    enums,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { REWARDS_VIP_TIERS_CONDITION_TYPES } from "../types";

export const RewardsVipTiersRewardSchema = union([
    RewardsPointsRewardSchema,
    RewardsDiscountExtraInfoRewardSchema,
    RewardsGiftCardRewardSchema,
    RewardsFreeProductRewardSchema,
]);

export const RewardsVipTierSchema = object({
    id: number(),
    title: string(),
    description: nullable(string()),
    perks: array(string()),
    pointsMultiplier: nullable(number()),
    image: nullable(RewardsIconSchema),
    condition: enums(Object.values(REWARDS_VIP_TIERS_CONDITION_TYPES)),
    conditionValue: number(),
    rewarding: nullable(RewardsVipTiersRewardSchema),
    isDefault: boolean(),
});

export const RewardsVipTiersResponseSchema = object({
    tiers: array(RewardsVipTierSchema),
});

export const RewardsVipTierProgressResponseSchema = object({
    progress: nullable(number()),
});
